/**
 * M5 (jun-2026) — Carrito global del Marketplace (badge + añadir items).
 * El pago sigue con candado legal; este contexto solo maneja el carrito.
 */
import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { marketplaceApi } from '@/lib/marketplaceApi';

const CartContext = createContext({
  count: 0,
  refresh: async () => {},
  addItem: async () => {},
  syncCount: () => {},
});

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const { user } = useAuth();
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!user) { setCount(0); return; }
    try {
      const res = await marketplaceApi.getCart();
      setCount(res.summary?.units_count ?? res.summary?.items_count ?? 0);
    } catch { /* sin sesión o error transitorio */ }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const addItem = useCallback(async (itemType, itemId, qty = 1) => {
    const res = await marketplaceApi.addCartItem({ item_type: itemType, item_id: itemId, qty });
    setCount(res.summary?.units_count ?? res.summary?.items_count ?? 0);
    return res;
  }, []);

  return (
    <CartContext.Provider value={{ count, refresh, addItem, syncCount: setCount }}>
      {children}
    </CartContext.Provider>
  );
};
